// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AccordionController from './accordion_controller'

import ActivityDistributorsController from './activity_distributors_controller'

import AlertBannerController from './alert_banner_controller'

import AlertDismissController from './alert_dismiss_controller'

import AnimationController from './animation_controller'

import BatchActivityOptInsController from './batch_activity_opt_ins_controller'

import BatchCollectionController from './batch_collection_controller'

import BodyController from './body_controller'

import ChecklistController from './checklist_controller'

import CollapsibleSectionController from './collapsible_section_controller'

import ContactGroupToggleController from './contact_group_toggle_controller'

import CurrentNameController from './current_name_controller'

import DatePickerController from './date_picker_controller'

import DisclosurePopoverController from './disclosure_popover_controller'

import DistributorCreditSubmissionsController from './distributor_credit_submissions_controller'

import DistributorVolumeSubmissionsController from './distributor_volume_submissions_controller'

import DragDropController from './drag_drop_controller'

import DropdownController from './dropdown_controller'

import FormConfirmationController from './form_confirmation_controller'

import FormController from './form_controller'

import FormEnablerController from './form_enabler_controller'

import ExportLinkController from './export_link_controller'

import ExpandAllToggleController from './expand_all_toggle_controller'

import FrozenTableController from './frozen_table_controller'

import ItemVerificationDistributorsController from './item_verification_distributors_controller'

import ModalController from './modal_controller'

import ModalManagerController from './modal_manager_controller'

import NavigationController from './navigation_controller'

import NestedProductsController from './nested_products_controller'

import OptInStatusController from './opt_in_status_controller'

import PhoneFormatterController from './phone_formatter_controller'

import PricingPerformanceBreakdownController from './pricing_performance_breakdown_controller'

import PricingStatewideRollupController from './pricing_statewide_rollup_controller'

import ProgressAnimationController from './progress_animation_controller'

import SalesActivityPartipationsController from './sales_activity_partipations_controller'

import ScrollController from './scroll_controller'

import SegmentedControlController from './segmented_control_controller'

import SupplierPricingParticipationsController from './supplier_pricing_participations_controller'

import TaskFormController from './task_form_controller'

import TextareaGrowController from './textarea_grow_controller'

import TimePreviewController from './time_preview_controller'

import ToggleController from './toggle_controller'
application.register('accordion', AccordionController)
application.register('activity-distributors', ActivityDistributorsController)
application.register('alert-banner', AlertBannerController)
application.register('alert-dismiss', AlertDismissController)
application.register('animation', AnimationController)
application.register('batch-activity-opt-ins', BatchActivityOptInsController)
application.register('batch-collection', BatchCollectionController)
application.register('body', BodyController)
application.register('checklist', ChecklistController)
application.register('collapsible-section', CollapsibleSectionController)
application.register('contact-group-toggle', ContactGroupToggleController)
application.register('current-name', CurrentNameController)
application.register('date-picker', DatePickerController)
application.register('disclosure-popover', DisclosurePopoverController)
application.register('distributor-credit-submissions', DistributorCreditSubmissionsController)
application.register('distributor-volume-submissions', DistributorVolumeSubmissionsController)
application.register('drag-drop', DragDropController)
application.register('dropdown', DropdownController)
application.register('form-confirmation', FormConfirmationController)
application.register('form', FormController)
application.register('form-enabler', FormEnablerController)
application.register('export-link', ExportLinkController)
application.register('expand-all-toggle', ExpandAllToggleController)
application.register('frozen-table', FrozenTableController)
application.register('item-verification-distributors', ItemVerificationDistributorsController)
application.register('modal', ModalController)
application.register('modal-manager', ModalManagerController)
application.register('navigation', NavigationController)
application.register('nested-products', NestedProductsController)
application.register('opt-in-status', OptInStatusController)
application.register('phone-formatter', PhoneFormatterController)
application.register('pricing-performance-breakdown', PricingPerformanceBreakdownController)
application.register('pricing-statewide-rollup', PricingStatewideRollupController)
application.register('progress-animation', ProgressAnimationController)
application.register('sales-activity-partipations', SalesActivityPartipationsController)
application.register('scroll', ScrollController)
application.register('segmented-control', SegmentedControlController)
application.register('supplier-pricing-participations', SupplierPricingParticipationsController)
application.register('task-form', TaskFormController)
application.register('textarea-grow', TextareaGrowController)
application.register('time-preview', TimePreviewController)
application.register('toggle', ToggleController)
